import { render, staticRenderFns } from "./DocSocial.vue?vue&type=template&id=4ed29aeb&scoped=true&"
import script from "./DocSocial.vue?vue&type=script&lang=js&"
export * from "./DocSocial.vue?vue&type=script&lang=js&"
import style0 from "./DocSocial.vue?vue&type=style&index=0&id=4ed29aeb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed29aeb",
  null
  
)

export default component.exports